import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const Headline = ({
  tag = 'h1',
  classNames,
  children,
  large,
  minor,
  hero,
  heroThin,
  heroSub,
  jumbo,
  sub
}) =>
  React.createElement(
    tag,
    {
      className: cn(
        'Headline',
        { minor, hero, heroThin, heroSub, jumbo, sub, large },
        classNames
      )
    },
    children
  )

Headline.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  minor: PropTypes.bool,
  large: PropTypes.bool,
  hero: PropTypes.bool,
  heroThin: PropTypes.bool,
  heroSub: PropTypes.bool,
  jumbo: PropTypes.bool,
  sub: PropTypes.bool
}

export default Headline
